import { render, staticRenderFns } from "./ReportAProblem.vue?vue&type=template&id=5b750440&scoped=true"
import script from "./ReportAProblem.vue?vue&type=script&lang=js"
export * from "./ReportAProblem.vue?vue&type=script&lang=js"
import style0 from "./ReportAProblem.vue?vue&type=style&index=0&id=5b750440&prod&lang=scss"
import style1 from "./ReportAProblem.vue?vue&type=style&index=1&id=5b750440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b750440",
  null
  
)

export default component.exports